import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';


const getLastOdontoSemio = async (idPaciente) => {

  if( !idPaciente ) return null;

  const query = `                    
    query ObtainLastOdontogramaAnual($paciente : !ID) {
    obtainLastOdontogramaAnual(paciente: $paciente) {
        id
        fechaCreacion
        ultimoCambio
        token
        fechaPrimeraToma
        data
        estado
    }
}

  `;


  const variables = {
    paciente : idPaciente
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.obtainLastOdontogramaAnual;

    if( response2.status !== 'success' ) return null;
    if( response2 === 0 ) return null;

    const data = response2[0];
    return data;

  } catch (error) {
    console.error(error);
    return null;
  }

}


const getData = async (tokenAtencion) => {

  if( !tokenAtencion ) return null;

  const query = `                    
    query AllAtenmedica($tokenAtencion:String) {
      allAtenmedica( tokenAtencion:$tokenAtencion ) {
        total
        status
        message
        atcm {
          id
          token
          semiologia
        }
      }
    }
  `;


  const variables = {
    tokenAtencion
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allAtenmedica;

    if( response2.status !== 'success' ) return null;
    if( response2.atcm.length === 0 ) return null;

    const data = response2.atcm[0];
    return data;

  } catch (error) {
    console.error(error);
    return null;
  }

}







export const semiologiasService = {

  getData,
  getLastOdontoSemio
}